import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { H, V } from '../../Layout';
import { useStyling } from '../../Theme';
import { extractInitials } from '../../../production/header/RoundAvatar';
import SecureImage from '../../components/SecureImage';
import ImageEditor from './ImageEditor';

export const ImageContainer = ({
    name,
    imageId,
    numOfLetters = 2,
    isInSidePanel = false,
    enableEdit = false,
    onChangeImage = undefined,
    customImageSize = undefined,
    customInitialsFontSize = undefined
}: {
    name: string;
    imageId: string;
    numOfLetters?: number;
    isInSidePanel?: boolean;
    enableEdit?: boolean;
    onChangeImage?: (_name: string, ref: string) => void;
    customImageSize?: string;
    customInitialsFontSize?: string;
}) => {
    const { theme, isDarkMode, isMobile } = useStyling();

    const initials = extractInitials(name).substring(0, numOfLetters);

    const imgSize = useMemo(() => {
        return customImageSize ? customImageSize : isInSidePanel ? '110px' : isMobile ? '110px' : '140px';
    }, [isInSidePanel, isMobile, customImageSize]);

    return (
        <V sx={{ width: 'fit-content' }}>
            <H
                sx={{
                    width: imgSize,
                    minWidth: imgSize,
                    height: imgSize,
                    position: 'relative',
                    borderRadius: 1,
                    color: `${theme.palette.text.disabled}`,
                    backgroundColor: theme.palette.grey[isDarkMode ? theme.palette.grey[200] : 100],
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: `1px solid ${theme.palette.grey[300]}`
                }}
            >
                <SecureImage
                    imageId={imageId}
                    style={{ width: '100%', height: '100%', borderRadius: '8px' }}
                    alt={name}
                    alternateComponent={
                        <Typography
                            fontSize={
                                customInitialsFontSize
                                    ? customInitialsFontSize
                                    : isMobile || isInSidePanel
                                      ? '50px'
                                      : '70px'
                            }
                        >
                            {initials}
                        </Typography>
                    }
                />
            </H>
            {enableEdit && (
                <V sx={{ alignItems: 'center' }}>
                    <ImageEditor imageId={imageId} onSaveImage={onChangeImage} />
                </V>
            )}
        </V>
    );
};
